"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = require("styled-components");

var _theme = _interopRequireDefault(require("./theme"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  :root {\n    ", "\n  }\n\n  html,\n  #__next,\n  body {\n    height: 100%;\n  }\n\n  #__next {\n    /* Reach ui modal appears as a sibiling in the DOM so creating a seperate stacking context\n     will allow the modal always to appear on the top of the elements within the app.\n     */\n    isolation: isolate;\n  }\n\n  button,\n  a {\n    cursor: pointer;\n  }\n\n  button:disabled,\n  button:disabled:hover {\n    cursor: not-allowed;\n    opacity: 0.5;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var GlobalStyle = (0, _styledComponents.createGlobalStyle)(_templateObject(), Object.keys(_theme["default"]).map(function (key) {
  return "--".concat(key, ": ").concat(_theme["default"][key], ";");
}));
var _default = GlobalStyle;
exports["default"] = _default;